import { isDemo } from '@dreryk/demo-variant-frontend';
import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar, ActionBarElementType, Button, ButtonVariant, Tooltip } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../translations';
import { CertificateFormController } from '../certificate.types';

import { useCurrentAccountCertificateSetCommand } from './CertificateSaveAction.hooks';

type CertificateSaveActionProps = Pick<CertificateFormController, 'handleSubmit' | 'setError'> & {
   readonly onSuccess: VoidFunction;
};

export const CertificateSaveAction = (props: CertificateSaveActionProps): JSX.Element => {
   const { executeAsync: saveCertificate } = useCurrentAccountCertificateSetCommand({
      onSuccess: props.onSuccess,
      onLoginFault: (): void => {
         props.setError('userPassword', {
            message: personnelTranslationKeys.myAccount.certificate.incorrectPersonalPassword,
         });
      },
      onCertificateNoLongerValid: (): void => {
         props.setError('certificateFileDescriptor', {
            message: personnelTranslationKeys.myAccount.certificate.incorrectCertificateValidity,
         });
      },
      onInvalidCertificateContainerFault: (): void => {
         props.setError('certificateFileDescriptor', {
            message: personnelTranslationKeys.myAccount.certificate.incorrectCertificate,
         });
      },
      onInvalidCertificateContainerPasswordFault: (): void => {
         props.setError('certificatePassword', {
            message: personnelTranslationKeys.myAccount.certificate.incorrectPassword,
         });
      },
   });

   if (isDemo()) {
      return (
         <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
            <Tooltip
               content={personnelTranslationKeys.myAccount.certificate.unavailableInDemo}
               testId={'certificateSave'}
            >
               <Button testId={'save'} label={commonTranslationKeys.save} disabled variant={ButtonVariant.PRIMARY} />
            </Tooltip>
         </ActionBar.Portal>
      );
   }

   return (
      <ActionBar.PrimaryButton
         testId={'save'}
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(saveCertificate)}
         variant={ButtonVariant.PRIMARY}
         blockingOperation
      />
   );
};
